import React from 'react';
import { useTranslation } from 'react-i18next';
import { GalleryImage } from './images';
import CloseSvg from "../assets/close.svg";

interface PhotoViewerProps {
    img: GalleryImage;
    handleClosePhotoViewer: () => void;
}

const PhotoViewer = ({ img, handleClosePhotoViewer }: PhotoViewerProps) => {
    const { t } = useTranslation();

    return (
        <div className='photo-viewer' onClick={handleClosePhotoViewer}>
            <div className='photo-viewer__img-text-wrapper' onClick={(e) => e.stopPropagation()}>
                <img src={img.img} alt={img.description} className="photo-viewer__img" />
                <div className="photo-viewer__text-wrapper">
                    <span className="photo-viewer__text">{img.description}</span>
                </div>
                <button className="photo-viewer__close-btn" onClick={handleClosePhotoViewer}>
                    <img src={CloseSvg} alt={t('closeButtonAlt')} className="photo-viewer__close-img" />
                </button>
            </div>
            <div className="photo-viewer__overlay"></div>
        </div>
    )
}

export default PhotoViewer;